import { useCallback, useEffect, useMemo, useState } from 'react';

/**
 * Tour run/remount state for catalog picker dialogs.
 * Pass resetWhen={!open} so the tour stops when the dialog closes.
 */
function useCatalogPickerTour({ resetWhen = false } = {}) {
  const [tourRun, setTourRun] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  useEffect(() => {
    if (resetWhen) {
      setTourRun(false);
    }
  }, [resetWhen]);

  const startTour = useCallback(() => {
    setTourKey(prev => prev + 1);
    setTourRun(true);
  }, []);

  const joyrideProps = useMemo(
    () => ({
      key: tourKey,
      run: tourRun,
      onRunChange: setTourRun,
    }),
    [tourKey, tourRun],
  );

  return {
    tourRun,
    tourKey,
    startTour,
    joyrideProps,
    disableEnforceFocus: tourRun,
  };
}

export default useCatalogPickerTour;
